import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type { IStore, IStores } from '@interfaces/store';

export interface IGetStoresParams {
	search?: string;
	inactive?: boolean;
	tenantId?: number;
	page?: number;
	pageLimit?: number;
}

@Injectable({
	providedIn: 'root',
})
export class StoresService {
	constructor(private readonly _http: HttpClient) {}

	getStores(queryParams?: IGetStoresParams) {
		return this._http.get<IStores>('stores', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	getStoreById(id: IStore['id']) {
		return this._http.get<IStore>(`stores/${id}`);
	}

	postStore(store: IStore) {
		return this._http.post<IStore>('stores', store);
	}

	updateStore(store: IStore) {
		return this._http.put<IStore>(`stores/${store.id}`, store);
	}

	deleteStore(id: IStore['id']) {
		return this._http.delete<IStore>(`stores/${id}`);
	}

	activate(id: IStore['id']) {
		return this._http.post<IStore>(`stores/${id}/activate`, {});
	}
}
